export default function getConfig(name: string): string {
  return (window as any).configs?.[name] || import.meta.env[name];
}
